import $ from "clients/RawClient";
import ActionTypes from "actions/action-types";
import { createAction } from "redux-actions";
import Routes from "routes";

const actions = {
  deliveryCutoffLoading: createAction(ActionTypes.FETCH_DELIVERY_CUTOFF_LOADING),
  deliveryCutoffReceived: createAction(ActionTypes.FETCH_DELIVERY_CUTOFF_SUCCESS),
  deliveryCutoffError: createAction(ActionTypes.FETCH_DELIVERY_CUTOFF_ERROR),
  deliveryCutoffClear: createAction(ActionTypes.CLEAR_DELIVERY_CUTOFF_VALUE),
  blackoutDaysReceived: createAction(ActionTypes.FETCH_BLACKOUT_DAYS_SUCCESS),
  blackoutDaysError: createAction(ActionTypes.FETCH_BLACKOUT_DAYS_ERROR),

  fetchDeliveryCutoffs: function (zipCode) {
    return function (dispatch) {
      dispatch(actions.deliveryCutoffLoading());
      $.ajax({
        url: "/shipping_cutoffs/" + zipCode,
        type: "GET",
        headers: {
          Accept: "application/json",
        },
      }).then(
        function (deliveryCutoffData) {
          dispatch(actions.deliveryCutoffReceived(deliveryCutoffData));
        },
        function (errorData) {
          dispatch(actions.deliveryCutoffError(errorData));
        }
      );
    };
  },

  // This method clear the shippingCutoff value saved in
  // the shared state. After executing it we will have no value
  // for shippingCutoff in the shared state.
  clearDeliveryCutoffs: function () {
    return function (dispatch) {
      dispatch(actions.deliveryCutoffClear());
    };
  },

  fetchBlackoutDays: function (zipCode) {
    const url = `${Routes.Grids.BlackoutDays}/${zipCode}`;

    return dispatch => {
      $.ajax({
        url: url,
        type: "GET",
      }).then(
        data => {
          dispatch(actions.blackoutDaysReceived(data));
        },
        errorThrown => {
          dispatch(actions.blackoutDaysError(errorThrown));
        }
      );
    };
  },
};

export default actions;

export const {
  deliveryCutoffLoading,
  deliveryCutoffReceived,
  deliveryCutoffError,
  deliveryCutoffClear,
  blackoutDaysReceived,
  blackoutDaysError,
  fetchDeliveryCutoffs,
  clearDeliveryCutoffs,
  fetchBlackoutDays,
} = actions;
